import { actionTypes } from '../../constants';
import { fromJS } from 'immutable';

const {
  THRESHOLD_VALIDATION_MESSAGE,
  TARGET_VALIDATION_MESSAGE,
  ALERT_VALIDATION_MESSAGE,
  TRANSACTION_VALIDATION_MESSAGE,
  ENABLE_EDIT_MODE,
  ENABLE_UNSAVED_LEAVE_POPUP,
} = actionTypes;

export const initialState = fromJS({
  showValidation: false,
  targetValidation: false,
  highAlertValidation: false,
  lowAlertValidation: false,
  projectionValidation: false,
  transactionAmountValidation: false,
  enableEditMode: false,
  enableUnsavedLeavePopup: false,
});

const validation = (state = initialState, action) => {
  switch (action.type) {
    case THRESHOLD_VALIDATION_MESSAGE:
      return state.set('thresholdValidation', action.showThresholdError);
    case TARGET_VALIDATION_MESSAGE:
      return state.set('targetValidation', action.showTargetError);
    case ALERT_VALIDATION_MESSAGE:
      return state.set(action.validationKey, action.showAlertError);
    case TRANSACTION_VALIDATION_MESSAGE:
      return state.set('transactionAmountValidation', action.transactionAmountValidation);
    case ENABLE_EDIT_MODE:
      return state.set('enableEditMode', action.enableEditMode);
    case ENABLE_UNSAVED_LEAVE_POPUP:
      return state.set('enableUnsavedLeavePopup', action.enableUnsavedLeavePopup);
    default:
      return state;
  }
};
export default validation;
